import React, { FunctionComponent } from 'react';

export const Loader: FunctionComponent<{}> = () => (
    <div className="page-width">
        <div
            style={{
                textAlign: 'center',
                padding: '3em',
            }}
        >
            <div className="winem8-spinner"></div>
        </div>
    </div>
);

export default Loader;
